export default {
    viewAttendanceReport: "gathering.report",
    viewAttendanceOverviewReport: "gathering.report.overview",
    viewAttendanceUpdateReport: "gathering.report.update",

    createGatherings: "gathering.create",
    deleteGatherings: "gathering.delete",
    updateGatherings: "gathering.update",
    viewGatherings: "gathering.view",
    gatheringRestriction: "gathering.restricted",

    createGroupCategories: "group.category.create",
    deleteGroupCategories: "group.category.delete",
    updateGroupCategories: "group.category.update",
    viewGroupCategories: "group.category.view",

    createGroupRoles: "group.role.create",
    deleteGroupRoles: "group.role.delete",
    updateGroupRoles: "group.role.update",
    viewGroupRoles: "group.role.view",

    createGroups: "group.create",
    deleteGroups: "group.delete",
    updateGroups: "group.update",
    viewGroups: "group.view",
    groupRestriction: "group.restricted",

    createGroupStatisticTemplates: "group-statistic-template.create",
    deleteGroupStatisticTemplates: "group-statistic-template.delete",
    updateGroupStatisticTemplates: "group-statistic-template.update",
    viewGroupStatisticTemplates: "group-statistic-template.view",

    createMembers: "member.create",
    deleteMembers: "member.delete",
    restoreMembers: "member.restore",
    updateMembers: "member.update",
    viewMembers: "member.view",
    validateMembers: "member.validate",

    createVisitors: "visitor.create",
    deleteVisitors: "visitor.delete",
    restoreVisitors: "visitor.restore",
    updateVisitors: "visitor.update",
    viewVisitors: "visitor.view",

    createMetricCategories: "metric-category.create",
    deleteMetricCategories: "metric-category.delete",
    updateMetricCategories: "metric-category.update",
    viewMetricCategories: "metric-category.view",

    createMetricRecords: "metric-record.create",
    deleteMetricRecords: "metric-record.delete",
    updateMetricRecords: "metric-record.update",
    viewMetricRecords: "metric-record.view",

    createMetrics: "metric.create",
    deleteMetrics: "metric.delete",
    updateMetrics: "metric.update",
    viewMetrics: "metric.view",

    createPotentialMembers: "member.potential.create",
    deletePotentialMembers: "member.potential.delete",
    updatePotentialMembers: "member.potential.update",
    viewPotentialMembers: "member.potential.view",

    createSms: "sms.create",
    deleteSms: "sms.delete",
    updateSms: "sms.update",
    viewSms: "sms.view",
    sendSms: "sms.send",

    createSmsObservers: "sms.observer.create",
    deleteSmsObservers: "sms.observer.delete",
    updateSmsObservers: "sms.observer.update",
    viewSmsObservers: "sms.observer.view",

    createUserRoles: "role.user.create",
    deleteUserRoles: "role.user.delete",
    updateUserRoles: "role.user.update",
    viewUserRoles: "role.user.view",

    updateTranslationBillings: "translation-billing.update",
    viewTranslationBillings: "translation-billing.view",

    convertTranslationDrafts: "translation-draft.convert",
    createTranslationDrafts: "translation-draft.create",
    deleteTranslationDrafts: "translation-draft.delete",
    translateTranslationDrafts: "translation-draft.translate",
    updateTranslationDrafts: "translation-draft.update",
    viewTranslationDrafts: "translation-draft.view",

    createTranslationUploadBatches: "translation-upload-batch.create",
    deleteTranslationUploadBatches: "translation-upload-batch.delete",
    updateTranslationUploadBatches: "translation-upload-batch.update",
    viewTranslationUploadBatches: "translation-upload-batch.view",
};
